import { Icon } from "@chakra-ui/react";

export default function LinkedIn({ ...props }) {
  return (
    <Icon width="32" height="32" viewBox="0 0 32 32" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M24.98 23.54v-6.247c0-3.346-1.787-4.904-4.169-4.904-1.922 0-2.783 1.058-3.263 1.8v-1.544h-3.622c.048 1.023 0 10.895 0 10.895h3.622v-6.085c0-.324.023-.65.12-.882.26-.65.856-1.324 1.856-1.324 1.311 0 1.835.998 1.835 2.462v5.83h3.62v-.001zM10.11 11.158c1.263 0 2.05-.837 2.05-1.883-.024-1.068-.787-1.881-2.026-1.881-1.238 0-2.048.812-2.048 1.881 0 1.046.786 1.883 2.002 1.883h.022zM16 32C7.164 32 0 24.836 0 16 0 7.163 7.164 0 16 0s16 7.163 16 16c0 8.836-7.164 16-16 16zm-4.078-8.46V12.645h-3.62V23.54h3.62z"
      />
    </Icon>
  );
}
